import { NgModule } from '@angular/core';

import { SuccessCheckmarkComponent } from './SuccessCheckmark.component';

@NgModule({
  declarations: [SuccessCheckmarkComponent],
  exports: [SuccessCheckmarkComponent],
})
export class MgSuccessCheckmarkModule {}
